import { ContentItem, ContentItemDetailed, ContentItemDetailedCreate } from 'app/shared/models';

export enum ContentTypes {
  html = 'html',
  json = 'json',
  markdown = 'markdown',
  text = 'text'
}
export type CContentType = 'text' | 'html' | 'json' | 'markdown'

export const ContentTypeIds = {
  'text': 1,
  'html': 2,
  'json': 3,
  'markdown': 4,
} as const
export type ContentTypeIdsType = (typeof ContentTypeIds)[keyof typeof ContentTypeIds];

export type ContentTypeIdKey = keyof typeof ContentTypeIds;
export type ContentTypeIdValue = (typeof ContentTypeIds)[ContentTypeIdKey];

export const ContentTypeArray: { key: ContentTypeIdKey; id: ContentTypeIdValue }[] =
  Object.entries(ContentTypeIds).map(([key, id]) => ({
    key: key as ContentTypeIdKey,
    id: id,
  }));
export interface Content {
  id: number;
  companyId?: number;
  key: string;
  renderOptions?: string;
  contentItems: ContentItem[];
  type?: string;
  visible?: boolean
  masterLanguageId?: number;
}

export type CreateContentDto = Omit<Content, 'id'>;

/* !TODD Refactoring of models */
/* Content and ContentDetailed are basically the same, but is used instead of EditContentModel in some cases */
export interface ContentDetailed {
  id: number;
  companyId?: number;
  key?: string;
  contentTypeId?: number;
  renderOptions?: string;
  contentItems: ContentItemDetailed[];
  order?: number;
}

export type ContentDetailedCreate = Omit<ContentDetailed, 'id' | 'contentitems'>
  & { id?: number, contentItems?: ContentItemDetailedCreate[] };

export type ContentItemDetailedWrapper = Pick<ContentDetailed, 'contentItems'>;

export interface ContentList {
  id: number;
  key: string;
  text: string[];
}

export type ContentDetailedList = ContentDetailed[] | ContentDetailedCreate[];
